export const getInfo = state => state.information;
